<template>
  <div>
    <h2>Отчеты для подписания</h2>

    <div class="row g-3">

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="bin" class="form-label col-md-3">Бин</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" class="form-control" id="bin" v-model="searchParams.bin">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingMonth" class="form-label col-md-3">Расчетный месяц</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min='1' max='12' step="1" class="form-control" id="accountingMonth" v-model="searchParams.accountingMonth">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingYear" class="form-label col-md-3">Расчетный год</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min='2024' step="1" class="form-control" id="accountingYear" v-model="searchParams.accountingYear">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="signStatus" class="form-label col-md-3">По статусу</label>
          <div class="col-md-9">
            <div class="input-group">
              <select v-model="searchParams.signStatus" id="signStatus" class="form-control">
                <option value="">Все статусы</option>
                <option value="SIGNED">Подписан</option>
                <option value="NOT_SIGNED">Не подписан</option>
                <option value="GENERATING">Выгружается</option>
                <option value="REJECTED_BY_HEAD">Отказано от Директора ДО</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="katoCode" class="form-label col-md-3">Населенный пункт</label>
          <div class="col-md-9">
            <div class="input-group">
              <multiselect
                  v-model="kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  track-by="code"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-7">
        <div class="el-input-group">
          <label v-if="hasAccess(adminWriteRoles)" class="me-2">
            <input type="checkbox" v-model="searchParams.includeDeleted" @change="fetchReports(true)"> Показать удалённые
          </label>
          <button class="btn btn-primary" @click="fetchReports(true)">Поиск</button>
          <button class="btn btn-warning" @click="clearSearchParam()">Сбросить фильтр</button>
          <button v-if="!isLoading" class="btn btn-info" @click="downloadGeneratedCalculationReportList()">Выгрузить результат по фильтру</button>
          <button v-else class="btn btn-loading" disabled>Загрузка</button>
          <button v-if="selectedLive.length > 0 && hasAccess(adminRoles)" class="btn btn-danger" @click="openDeletionConfirmationModal">Удалить выбранные отчеты</button>
          <button v-if="selectedDeleted.length > 0 && hasAccess(adminWriteRoles)" class="btn btn-success" @click="showRestoreModal = true">Восстановить выбранные</button>
        </div>
      </div>

      <div class="col-md-3">
        <div class="el-input-group">
          <button v-if="hasAccess([...adminRoles, ...managerRoles])" type="button" class="open-modal-btn" @click="openModal">Создать .PDF отчет для подписание</button>
        </div>
      </div>

    </div>

    <DeleteReasonDialog v-model="showDeleteConfirmationModal" title="Вы точно хотите удалить выбранные отчеты?" :loading="deleteLoading" @confirm="handleDeleteSelectedElements">
      <el-table :data="deleteConfirmationContent" style="width: 100%">
        <el-table-column prop="bin" label="БИН ДО"></el-table-column>
        <el-table-column prop="lmsId" label="LMS ID"></el-table-column>
      </el-table>
    </DeleteReasonDialog>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h4>Выберите БИНов и отчетное время для создание .pdf</h4>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="binList" class="form-label">Список БИНов (пишите через запятую или один за другим)</label>
            <textarea id="binList" cols="30" rows="10" class="form-control" v-model="calculationFormFields.binListStr"
                      placeholder="1234567, 1234567, ...
или
1234567
1234567
..."></textarea>
          </div>
          <div class="form-group">
            <label for="lmsIdList" class="form-label">Список Lms Id (пишите через запятую или один за другим)</label>
            <textarea id="lmsIdList" cols="30" rows="10" class="form-control" v-model="calculationFormFields.lmsIdListStr"
                      placeholder="1-3-308, 1-3-309, ...
или
1-2-345
6-7-891
..."></textarea>
          </div>
          <div class="form-group">
            <label for="accountingMonth" class="form-label">Отчетный месяц</label>
            <input type="number" min="1" max="12" step="1" id="accountingMonth" class="form-control" required v-model="calculationFormFields.accountingMonth">
          </div>
          <div class="form-group">
            <label for="accountingYear" class="form-label">Отчетный год</label>
            <input type="number" min="2024" step="1" id="accountingYear" class="form-control" required v-model="calculationFormFields.accountingYear">
          </div>
          <div class="form-group">
            <button type="submit" class="submit-btn" :disable="isFormLoading">
              {{ isFormLoading ? 'Загружается...' : 'Загрузить' }}
            </button>
          </div>
        </form>
        <button class="close-modal-btn" @click="closeModal">Закрыть</button>
      </div>
    </div>

    <p></p>
    <div class="row">
      <div class="col-md-4">
        <b-pagination v-model="currentPage" :total-rows="pageResponse?.totalElements" :per-page="searchParams.pageSize"></b-pagination>
      </div>
      <div class="col-md-4">
        <span>Элементов в странице: </span>
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-secondary" :class="{'active': searchParams.pageSize == 10}" @click="changePageElementSize(10)">10</button>
          <button type="button" class="btn btn-secondary" :class="{'active': searchParams.pageSize == 50}" @click="changePageElementSize(50)">50</button>
          <button type="button" class="btn btn-secondary" :class="{'active': searchParams.pageSize == 100}" @click="changePageElementSize(100)">100</button>
        </div>
      </div>
    </div>
    <DeleteReasonDialog v-model="showRestoreModal" variant="restore" title="Восстановить выбранные отчеты?" confirm-text="Восстановить" reason-label="Причина восстановления" :loading="deleteLoading" @confirm="handleRestoreSelectedElements">
      <p>Выбрано отчётов: {{ selectedDeleted.length }}. Будут восстановлены отчёт, акт сверки и счёт-фактура.</p>
    </DeleteReasonDialog>

    <el-table :data="reports" style="width: 100%" :row-class-name="rowClassName">
      <el-table-column type="index" label="#" width="50">
        <template v-if="hasAccess(adminRoles)" #default="scope">
          <label class="btn btn-outline-light">
            <input type="checkbox" :value="scope.row.id" v-model="selectedKindergartenCalculations">
          </label>
        </template>
      </el-table-column>

      <el-table-column type="expand" label="Детали">
        <template #default="props">
          <div v-if="props.row.calculationReportInfo" class="m-4">
            <p>Дата создание документа: {{ props.row.calculationReportInfo.currentDate }}</p>
            <el-table :data="props.row.calculationReportInfo.calculationTableData">
              <el-table-column label="#" prop="number"></el-table-column>
              <el-table-column label="ИИН" prop="childIin"></el-table-column>
              <el-table-column label="ФИО" prop="childFIO"></el-table-column>
              <el-table-column label="Время прибывание" prop="durationTime"></el-table-column>
              <el-table-column label="Рабочие дни" prop="workingDays"></el-table-column>
              <el-table-column label="Отсутствие по уваж." prop="excusedAbsenceDays"></el-table-column>
              <el-table-column label="Отсутствие по не уваж." prop="unexcusedAbsenceDays"></el-table-column>
              <el-table-column label="Присутствовал" prop="presenceDays"></el-table-column>
              <el-table-column label="Перерасчет" prop="recalculationAmount"></el-table-column>
              <el-table-column label="Сумма" prop="sum"></el-table-column>
            </el-table>
          </div>
          <div v-else class="m-4">
            Нет данных
          </div>
        </template>
      </el-table-column>

      <el-table-column
          label="Название файла">
        <template #default="scope">
          <a
              v-if="scope.row.signStatus !== 'GENERATING'"
              @click="handleDownload(scope.row.report.uuid, scope.row.report.fileName)"
              :class="{ 'active-link': scope.row.signStatus !== 'GENERATING' }"
          >
            {{ scope.row.report.fileName }}
          </a>
          <span v-else>
            {{ scope.row.report.fileName }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Название ДО">
        <template #default="scope">
          {{ scope.row.lmsSystem.kindergartenName }}
        </template>
      </el-table-column>

      <el-table-column label="Населенный пункт">
        <template #default="scope">
          {{ getKatoNameRu(scope.row.report.katoCode) }}
        </template>
      </el-table-column>

      <el-table-column label="БИН и LMS ID">
        <template #default="scope">
          {{ scope.row.bin }} <br> {{ scope.row.lmsSystem.lmsId }}
        </template>
      </el-table-column>

      <el-table-column label="Расчетное время ММ.ГГГГ">
        <template #default="scope">
          {{ scope.row.accountingMonth }}.{{ scope.row.accountingYear }}
        </template>
      </el-table-column>

      <el-table-column
        prop="childCount"
        label="Кол-во детей">
      </el-table-column>

      <el-table-column
        prop="totalSum"
        label="Сумма">
      </el-table-column>

      <el-table-column
          prop="signStatus"
          label="Статус подписи">
        <template #default="scope">
          <span :class="{ 'rejected-status': scope.row.signStatus === 'REJECTED_BY_HEAD' }">{{ getSignStatusText(scope.row.signStatus) }}</span>
          <br>
          <span>{{ scope.row.rejectComment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Текст ошибки">
        <template #default="scope">
          <span>{{ scope.row.report.reportStatusText }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, ref, onMounted, reactive, watch} from 'vue';
import {
  deleteSelectedKindergartenCalculations,
  restoreSelectedKindergartenCalculations,
  downloadReportFile,
  generateCalculationReportList,
  getAllKindergartenCalculation,
  getGeneratedCalculationReportList
} from '@/services/reportService';
import {
  CalculationReportResponse,
  KindergartenCalculationReport,
  KindergartenCalculationSearchParam
} from '@/types/report';
import {PageResponse} from "@/types/pageResponse";
import Multiselect from "vue-multiselect";
import {Kato} from "@/types/kindergarten";
import cacheService from "@/services/cacheService";
import { ElMessage } from 'element-plus';
import DeleteReasonDialog from "@/components/DeleteReasonDialog.vue";
import { extractApiError } from "@/utils/apiError";
import authService from "@/services/authService";
import {SearchParam} from "@/types/searchParam";

export default defineComponent({
  name: 'ReportToSignView',
  components: {Multiselect, DeleteReasonDialog},
  setup() {
    const pageResponse = ref<PageResponse<KindergartenCalculationReport>>();
    const reports = ref<KindergartenCalculationReport[]>([]);
    const currentPage = ref(1);
    const page = ref(1);
    const pageSize = ref(10);
    const searchParams = reactive(new KindergartenCalculationSearchParam());
    const kato = ref<Kato | null>(null);
    const katoList = ref<Kato[]>([]);
    const isLoading = ref(false);
    const isFormLoading = ref(false);
    const showModal = ref(false);
    const calculationFormFields = ref<CalculationReportResponse>({
      accountingMonth: new Date().getMonth() + 1,
      accountingYear: new Date().getFullYear(),
      binListStr: "",
      lmsIdListStr: ""
    });
    const selectedKindergartenCalculations = ref<number[]>([]);
    const hasAccess = authService.hasAccess;
    const adminRoles: string[] = authService.getAdminRoles();
    const managerRoles: string[] = authService.getManagerRoles();
    const showDeleteConfirmationModal = ref(false);
    const deleteLoading = ref(false);
    const deleteConfirmationContent = ref({});

    const openModal = () => {
      calculationFormFields.value.binListStr = "";
      calculationFormFields.value.lmsIdListStr = "";
      calculationFormFields.value.accountingMonth = new Date().getMonth() + 1;
      calculationFormFields.value.accountingYear = new Date().getFullYear();
      isFormLoading.value = false;
      showModal.value = true;
    };
    const closeModal = () => {
      showModal.value = false;
    };

    const fetchCachedData = async () => {
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    const fetchReports = async (isPageDefault: boolean = false) => {
      try {
        if (isPageDefault) {
          searchParams.page = 0;
          currentPage.value = 1;
        }
        if (kato.value) {
          searchParams.katoCode = kato.value?.code;
        }
        pageResponse.value = await getAllKindergartenCalculation(searchParams);
        reports.value = pageResponse.value.content;
      } catch (error) {
        console.error('Ошибка при получении отчетов:', error);
      }
    };

    watch(currentPage, (newPage) => {
      searchParams.page = newPage - 1;
      fetchReports();
    });

    const changePageElementSize = (pageSize: number) => {
      searchParams.pageSize = pageSize;
      console.log("searchParams", pageSize, searchParams);
      fetchReports();
    }

    const getSignStatusText = (status: string) => {
      switch (status) {
        case 'SIGNED':
          return 'Подписан';
        case 'NOT_SIGNED':
          return 'Не подписан';
        case 'GENERATING':
          return 'Выгружается';
        case 'REJECTED_BY_HEAD':
          return 'Отказано от Директора ДО';
        default:
          return 'Неизвестный статус';
      }
    };

    const handleDownload = async (fileId: string, fileName: string) => {
      try {
        const token = localStorage.getItem("access_token");
        if (token) {
          await downloadReportFile(token, fileId, fileName);
        }
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
      }
    };

    onMounted(() => {
      fetchReports();
      fetchCachedData();
    });

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    const clearSearchParam = () => {
      kato.value = null;
      searchParams.accountingMonth = null;
      searchParams.accountingYear = null;
      searchParams.bin = null;
      searchParams.signStatus = null;
      searchParams.katoCode = null;
    }

    const getKatoNameRu = (katoCode: number) => {
      const kato = katoList.value.find(kato => kato.code === katoCode);
      return kato ? kato.nameRu : "";
    }

    const downloadGeneratedCalculationReportList = async () => {
      try {
        isLoading.value = true;
        if (kato.value) {
          searchParams.katoCode = kato.value?.code;
        }
        await getGeneratedCalculationReportList(searchParams);
        isLoading.value = false;
      } catch (error) {
        isLoading.value = false;
        console.error(error);
      }
    }

    const adminWriteRoles: string[] = authService.getAdminWriteRoles();
    const showRestoreModal = ref(false);
    const selectedRows = (): KindergartenCalculationReport[] => (reports.value ?? []).filter((r: KindergartenCalculationReport) => selectedKindergartenCalculations.value.includes(r.id));
    const selectedLive = computed(() => selectedRows().filter((r: KindergartenCalculationReport) => !r.report?.deletion));
    const selectedDeleted = computed(() => selectedRows().filter((r: KindergartenCalculationReport) => !!r.report?.deletion));
    const rowClassName = ({ row }: { row: KindergartenCalculationReport }) => (row.report?.deletion ? "deleted-row" : "");

    const handleRestoreSelectedElements = async(reason: string) => {
      deleteLoading.value = true;
      try {
        await restoreSelectedKindergartenCalculations(selectedDeleted.value.map((r: KindergartenCalculationReport) => r.id), reason);
        location.reload();
        return;
      } catch (error) {
        ElMessage({ message: extractApiError(error, "Восстановление не прошло"), type: "error", showClose: true });
      }
      deleteLoading.value = false;
    }

    const handleDeleteSelectedElements = async(reason: string) => {
      deleteLoading.value = true;
      try {
        const statusCode = await deleteSelectedKindergartenCalculations(selectedLive.value.map((r: KindergartenCalculationReport) => r.id), reason);
        if (statusCode == 200) {
          location.reload();
          return;
        }
        ElMessage({ message: "Неизвестная ошибка, удаление не прошло", type: "error", showClose: true });
      } catch (error) {
        ElMessage({ message: extractApiError(error, "Удаление не прошло"), type: "error", showClose: true });
      }
      deleteLoading.value = false;
    }

    const handleSubmit = async() => {
      try {
        const binList = calculationFormFields.value.binListStr?.trim();
        const lmsIdList = calculationFormFields.value.lmsIdListStr?.trim();

        if ((!binList || binList === "") && (!lmsIdList || lmsIdList === "")) {
          ElMessage({
            message: "Укажите хотя бы одно из полей (БИН или LMS ID).",
            type: "error",
            showClose: true,
          });
          isFormLoading.value = false;
          return;
        }

        if (binList && lmsIdList) {
          ElMessage({
            message: "Заполните только одно из полей (БИН или LMS ID).",
            type: "error",
            showClose: true,
          });
          isFormLoading.value = false;
          return;
        }

        isFormLoading.value = true;
        if (calculationFormFields) {
          await generateCalculationReportList(calculationFormFields.value);
        }
        isFormLoading.value = false;
        window.location.reload();
      } catch (error) {
        console.error(error);
        isFormLoading.value = false;
      }
    };

    const openDeletionConfirmationModal = () => {
      showDeleteConfirmationModal.value = true;
      deleteConfirmationContent.value = reports.value
          .filter((r: KindergartenCalculationReport) => {
            const reportId = r.id;
            return reportId && selectedKindergartenCalculations.value.includes(reportId);
          })
          .map((r: KindergartenCalculationReport) => ({
            bin: r.bin,
            lmsId: r.lmsId
          }));
    }

    return {
      reports,
      pageResponse,
      page,
      pageSize,
      currentPage,
      searchParams,
      isLoading,
      kato,
      katoList,
      calculationFormFields,
      isFormLoading,
      showModal,
      selectedKindergartenCalculations,
      adminRoles,
      adminWriteRoles,
      managerRoles,
      selectedLive,
      selectedDeleted,
      showRestoreModal,
      rowClassName,
      handleRestoreSelectedElements,
      showDeleteConfirmationModal,
      deleteLoading,
      deleteConfirmationContent,
      hasAccess,
      openModal,
      closeModal,
      fetchReports,
      handleDownload,
      formattedKatoLabel,
      clearSearchParam,
      getKatoNameRu,
      getSignStatusText,
      downloadGeneratedCalculationReportList,
      handleSubmit,
      changePageElementSize,
      openDeletionConfirmationModal,
      handleDeleteSelectedElements
    };
  },
});
</script>

<style scoped>

.rejected-status {
  color: red;
}


.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}

</style>

<style>
.el-table .deleted-row {
  background-color: #fdecea;
  color: #8a8a8a;
}
</style>
